import React from 'react'
import {Link} from 'react-router-dom'



function Members(props){


  const imageStyle = {
    width: '100%',
}


  return(
   <div className="container">
     <div className="row m-3">
       <div className="col-12 text-center">
         <h1>LAB MEMBERS</h1>
       </div>
     </div>

     <div className="row">
       <div className="col-6">
         <h4>Professor</h4>
       </div>
     </div>

     <div className="row col-md-9 col-lg-6">
       <div className="col-6 bg-light">
        <img src={ require("../images/professor.gif") } style={imageStyle}/>
      </div>
      <div className="col-6">
        <br/><br/>
        <p> <strong>Professor Oh Jong-Won</strong> </p>
        <p> <strong>Phone number:</strong> 02-362-7265</p>
        <p> <strong>Email: </strong>jwoh@yonsei.ac.kr</p>
        <p> <strong>Website: </strong> <a href="http://www.viromics.co.kr" target="_blank">viromics lab</a> </p>
        <Link to="/professor"> <button className="btn btn-primary" >About me</button></Link>
       </div>
     </div>

      <br/><hr/><br/><br/>

     <div className="row">
       <div className="col">
         <h4>Graduate Students</h4>
       </div>
     </div>
     <br/>

     <div className="row bg-light">

       <div className="col-md-6 my-3">
         <div className="row">
          <div className="col-4">
            <img src={ require("../images/face.png") } style={imageStyle}/>
          </div>
          <div className="col-8">
            <br/>
            <p>Name</p>
            <p>Tel: 000-0000-0000</p>
            <p>Email: someone@yonsei.ac.kr</p>
          </div>
        </div>
        <hr/>
       </div>
     
      <div className="col-md-6 my-3">
        <div className="row">
        <div className="col-4">
          <img src={ require("../images/face.png") } style={imageStyle}/>
        </div>
        <div className="col-8">
        <br/>
          <p>Name</p>
          <p>Tel: 000-0000-0000</p>
          <p>Email: someone@yonsei.ac.kr</p>
        </div>
        </div>
        <hr/>
      </div>
      

      <div className="col-md-6 my-3">
         <div className="row">
          <div className="col-4">
            <img src={ require("../images/face.png") } style={imageStyle}/>
          </div>
          <div className="col-8">
            <br/>
            <p>Name</p>
            <p>Tel: 000-0000-0000</p>
            <p>Email: someone@yonsei.ac.kr</p>
          </div>
        </div>
        <hr/>
       </div>
     
      <div className="col-md-6 my-3">
        <div className="row">
        <div className="col-4">
          <img src={ require("../images/face.png") } style={imageStyle}/>
        </div>
        <div className="col-8">
        <br/>
          <p>Name</p>
          <p>Tel: 000-0000-0000</p>
          <p>Email: someone@yonsei.ac.kr</p>
        </div>
        </div>
        <hr/>
      </div>
      <hr/>

   </div>
   <br/><br/><br/>

   <div className="row my-3 ">
     <div className="col">
       <h4>Alumni</h4>
     </div>
   </div>

    <div className="row bg-light">

      <div className="col-md-6 my-3">
        <div className="row">
        <div className="col-4">
          <img src={ require("../images/face.png") } style={imageStyle}/>
        </div>
        <div className="col-8">
          <br/>
          <p>Name</p>
          <p>Tel: 000-0000-0000</p>
          <p>Email: someone@yonsei.ac.kr</p>
        </div>
      </div>
      <hr/>
      </div>
     
      <div className="col-md-6 my-3">
        <div className="row">
        <div className="col-4">
          <img src={ require("../images/face.png") } style={imageStyle}/>
        </div>
        <div className="col-8">
        <br/>
          <p>Name</p>
          <p>Tel: 000-0000-0000</p>
          <p>Email: someone@yonsei.ac.kr</p>
        </div>
        </div>
        <hr/>
      </div>
      

      <div className="col-md-6 my-3">
         <div className="row">
          <div className="col-4">
            <img src={ require("../images/face.png") } style={imageStyle}/>
          </div>
          <div className="col-8">
            <br/>
            <p>Name</p>
            <p>Tel: 000-0000-0000</p>
            <p>Email: someone@yonsei.ac.kr</p>
          </div>
        </div>
        <hr/>
       </div>
     
      <div className="col-md-6 my-3">
        <div className="row">
        <div className="col-4">
          <img src={ require("../images/face.png") } style={imageStyle}/>
        </div>
        <div className="col-8">
        <br/>
          <p>Name</p>
          <p>Tel: 000-0000-0000</p>
          <p>Email: someone@yonsei.ac.kr</p>
        </div>
        </div>
        <hr/>
      </div>
      <hr/>

   </div>


    <br/><br/><br/>
   </div>
    
  )
}


export default Members